import { render } from "./ViewSubmission.vue?vue&type=template&id=0736d2b2&scoped=true"
import script from "./ViewSubmission.vue?vue&type=script&lang=js"
export * from "./ViewSubmission.vue?vue&type=script&lang=js"

import "./ViewSubmission.vue?vue&type=style&index=0&id=0736d2b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0736d2b2"]])

export default __exports__